import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortfolioCmm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_24641_5762)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_24641_5762",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16 0H0V16H16V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_24641_5762)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.495 8.1381C5.66886 7.99587 5.93165 8.04851 6.45691 8.1547L7.11414 8.28752C7.47813 8.36111 7.66031 8.39873 7.76746 8.5297C7.87438 8.66065 7.87488 8.84616 7.87488 9.2172V14.4526C7.87488 14.9775 7.8745 15.2401 7.70496 15.3822C7.53504 15.5244 7.27593 15.478 6.75867 15.3852L6.10144 15.267C5.72854 15.2001 5.54192 15.1666 5.43152 15.0346C5.32127 14.9026 5.32117 14.7132 5.32117 14.3344V9.08439C5.32117 8.54839 5.32118 8.28038 5.495 8.1381ZM8.61218 0.262126C8.78473 0.119915 9.04656 0.170212 9.56921 0.271892L10.2264 0.399821C10.5935 0.471231 10.7774 0.506771 10.8856 0.638103C10.9938 0.769421 10.993 0.956644 10.993 1.33049V10.8149C10.993 11.3486 10.9932 11.616 10.8202 11.7582C10.6472 11.9001 10.3853 11.8487 9.86218 11.7455L9.20496 11.6156C8.83894 11.5435 8.6556 11.5076 8.54773 11.3764C8.43986 11.2452 8.44031 11.058 8.44031 10.685V1.20256C8.44031 0.670642 8.44012 0.404428 8.61218 0.262126ZM2.43835 4.71916C2.60595 4.57747 2.86201 4.62021 3.3739 4.70549L3.96082 4.80314C4.33903 4.86615 4.52817 4.89809 4.6405 5.03068C4.75264 5.1633 4.75281 5.3553 4.75281 5.73869V9.54142C4.75281 10.0741 4.75259 10.3406 4.57996 10.4828C4.40728 10.6248 4.14564 10.5741 3.62292 10.4721L3.03699 10.3578C2.67021 10.2863 2.48695 10.2498 2.37878 10.1186C2.27067 9.98732 2.27039 9.80063 2.27039 9.42717V5.64103C2.27039 5.12149 2.27072 4.86118 2.43835 4.71916ZM11.7343 3.73478C11.906 3.59281 12.1666 3.64281 12.6874 3.74162L13.3446 3.86564C13.7136 3.93565 13.8978 3.9714 14.0067 4.10295C14.1155 4.23448 14.1161 4.42194 14.1161 4.79728V8.62443C14.1161 9.15461 14.1158 9.41971 13.9442 9.56193C13.7725 9.70411 13.512 9.65491 12.9911 9.55607L12.3339 9.43107C11.965 9.36109 11.7807 9.32618 11.6718 9.19474C11.5628 9.06318 11.5624 8.87504 11.5624 8.49943V4.67326C11.5624 4.14296 11.5625 3.87698 11.7343 3.73478Z",
				fill: "#52A2FF"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_24641_5762",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgPortfolioCmm;
